var ResponsiveCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 8,
	slidesToScroll: 2,
	responsive: [
		{
			breakpoint: 779, //10px gap - on 769px slick is not behaving properly
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true,
			},
		},
	],
};
var PDPMainCarouselConfig = {
	slidesToShow: 1,
	vertical: true,
	arrows: false,
	dots: true
};

var PDPThumbnailCarouselConfig = {
	slidesToShow: 4,
	vertical: true,
	focusOnSelect: true,
	infinite: false,
	arrows: true,
	prevArrow: '<div class="slick-prev"></div>',
	nextArrow: '<div class="slick-next"></div>'
};

var RecommendationCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 4.5,
	slidesToScroll: 4,
	arrows: false,
	centerPadding: '0px',
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2.5,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1.5,
				slidesToScroll: 1,
				centerMode: true
			}
		}
	],
};

var UpsellRecommendationCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 8,
	slidesToScroll: 4,
	arrows: false,
	centerPadding: '0px',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3.5,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 1280,
			settings: {
				slidesToShow: 6,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2.5,
				slidesToScroll: 1
			}
		}
	],
};

var MiniCartFlyOutRecommendationCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 1.5,
	slidesToScroll: 1,
	arrows: false,
	centerPadding: '0px'
};

var SimilarItemCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 3,
	arrows: false,
	centerPadding: '0px',
	responsive: [
		{
			breakpoint: 779,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
	],
};

var MiniCartCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	centerMode: true
};

var CYOCarouselConfig = {
	dots: true,
	infinite: false,
	speed: 300,
	slidesToShow: 4,
	slidesToScroll: 2,
	responsive: [
		{
			breakpoint: 779, //10px gap - on 769px slick is not behaving properly
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			},
		},
	],
};

module.exports = { ResponsiveCarouselConfig, PDPMainCarouselConfig, PDPThumbnailCarouselConfig, RecommendationCarouselConfig,SimilarItemCarouselConfig, MiniCartCarouselConfig, MiniCartFlyOutRecommendationCarouselConfig, CYOCarouselConfig ,UpsellRecommendationCarouselConfig};
